import { IncomeCategory } from '../income-categories/income-category';

export class Income {
  public id?: string;
  public incomeCategory?: IncomeCategory;
  public name: string;
}
